<app-widget-card-wrapper [title]="chartTitle" [hide]="!hasData">
  <div class="card-stretch text-center">
    <div [id]="id" echarts [options]="chartOptions" *ngIf="chartOptions" theme="macarons"></div>
  </div>
</app-widget-card-wrapper>
